export enum ModalType {
    AddToCart = "add-to-cart",
    ForgotPassword = "forgot-password",
    Cashback = "cashback-modal",
    ReviewWrite = "review-write",
    ReviewGuidance = "review-guidance",
    ReviewTermsAndConditions = "review-terms-and-conditions",
    ReviewPhotoGuidance = "review-photo-guidance",
    ImageViewer = "image-viewer",
    EnergyLabel = "energy-label",
    TransportService = "transport-service",
    HasAccount = "has-account",
    NewsletterUnsubscribe = "newsletter-unsubscribe-modal",
    GuaranteeNotice = "guarantee-notice-modal",
    BonusCardRequest = "bonus-card-request",
    BonusCardRemoveConfirm = "bonus-card-remove-confirm",
    InvalidAddress = "invalid-address",
    CreateAddress = "create-address",
    EditAddress = "edit-address",
    DeleteAddress = "delete-address",
    AddressList = "address-list",
    CtaSelect = "cta-select",
    ProductConfiguration = "product-configuration",
    CheckoutCustomerDetails = "checkout-customer-details",
    Confirm = "confirm",
    InactivityMonitor = "inactivity-monitor",
    ReviewImages = "review-images",
    ReviewAuthorInfo = "review-author-info",
    ProfileEditEmail = "profile-edit-email",
    ProfileEditPassword = "profile-edit-password",
    ProfileEditDetails = "profile-edit-details",
    ProfileEditPreferences = "profile-edit-preferences",
    Share = "share",
    StorePicker = "store-picker",
    WishlistAdd = "wishlist-add",
    WishlistMove = "wishlist-move",
    WishlistCreate = "wishlist-create",
    WishlistRename = "wishlist-rename"
}

export const $ModalModuleName = "modal";

export type ModalId = ModalType | `${ModalType}-${string}`;

export type TModalState = Array<ModalId>;
